<template>
  <w-icon-wrapper icon-name='work-electric-magnifier-icon'>
    <path 
      id="Pfad_3" 
      data-name="Pfad 3" 
      d="M23.707,22.293l-6.82-6.82a9.509,9.509,0,1,0-1.415,1.414l6.821,6.82a1,1,0,0,0,1.414-1.414M9.5,17A7.5,7.5,0,0,1,4.2,4.2,7.5,7.5,0,1,1,14.8,14.8,7.448,7.448,0,0,1,9.5,17" 
      fill="#4173ff"
    />
    
    <path 
      id="Pfad_4" 
      data-name="Pfad 4" 
      d="M8.46,15.62V10.45H5.25l5.03-6.7V8.91h3.21Z" 
      fill="#4173ff"
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconElectricMagnifier' };
</script>
